import React, {Component} from 'react';
import {Button, Menu} from 'semantic-ui-react';
import {connect} from 'react-redux';
import {logout} from '../../data/user/actions'
import {isLoggedIn} from '../../reducer';
import {Translate} from "react-localize-redux";





class LogoutButton extends Component {

    render() {
        if (this.props.loggedIn) {
            return (
                <Menu.Item position='right'>
                    <Button onClick={this.props.logout.bind(this)}  inverted={!this.props.fixed}  style={{marginLeft: '0.5em'}}>
                        <Translate id="logout" />
                    </Button>
                </Menu.Item>
            );
        }

        return null;
    }
}

const mapStateToProps = state => ({
    loggedIn: isLoggedIn(state)
})



const mapDispatchToProps = (dispatch) => {
    return({
        logout: () => {dispatch(logout())}
    })
}


export default connect(
    mapStateToProps,
    mapDispatchToProps,
    null
)(LogoutButton)


// WEBPACK FOOTER //
// ./src/components/LogoutButton/index.js